var r = "ResizeObserver loop completed with undelivered notifications.", t = function() {
  var e;
  typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
    message: r
  }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = r), window.dispatchEvent(e);
};
export {
  t as deliverResizeLoopError
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/algorithms/deliverResizeLoopError.js
// module id = 1310
// module chunks = 41